import { createReducer } from 'redux-act';
import actions from '../actions/separationActions';

const initialState = {
    applySeparationPending: false,
    applySeparationRes: null,
    applySeparationError: null,

    updateSeparationPending: false,
    updateSeparationRes: null,
    updateSeparationError: null,

    getSeparationPending: false,
    getSeparationRes: null,
    getSeparationError: null,

    getSeparationApprovalPending: false,
    getSeparationApprovalRes: null,
    getSeparationApprovalError: null,

    approveRejectSeparationPending: false,
    approveRejectSeparationRes: null,
    approveRejectSeparationError: null,

    getClearanceQuestionPending: false,
    getClearanceQuestionRes: null,
    getClearanceQuestionError: null,

    applyClearanceFormPending: false,
    applyClearanceFormRes: null,
    applyClearanceFormError: null,

    separationDetailsPending: false,
    separationDetailsRes: null,
    separationDetailsError: null,

    getClearancePending: false,
    getClearanceRes: null,
    getClearanceError: null,
};
/* Add Separation Reducers */
const handleApplySeparationRequest = state => {
    return {
        ...state,
        ...{
            applySeparationPending: true,
            applySeparationRes: null,
            applySeparationError: null,
        },
    };
};
const handleApplySeparationSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            applySeparationPending: false,
            applySeparationRes: payload,
            applySeparationError: null,
        },
    };
};
const handleApplySeparationError = (state, payload) => ({
    ...state,
    ...{
        applySeparationPending: false,
        applySeparationRes: null,
        applySeparationError: payload,
    },
});


/* Get Separation Reducers */
const handleUpdateSeparationRequest = state1 => {
    return {
        ...state1,
        ...{
            updateSeparationPending: true,
            updateSeparationRes: null,
            updateSeparationError: null,
        },
    };
};
const handleUpdateSeparationSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateSeparationPending: false,
            updateSeparationRes: payload,
            updateSeparationError: null,
        },
    };
};
const handleUpdateSeparationError = (state1, payload) => ({
    ...state1,
    ...{
        updateSeparationPending: false,
        updateSeparationRes: null,
        updateSeparationError: payload,
    },
});


/* Get SeparationReducers */
const handleGetSeparationRequest = state1 => {
    return {
        ...state1,
        ...{
            getSeparationPending: true,
            getSeparationRes: null,
            getSeparationError: null,
        },
    };
};
const handleGetSeparationSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getSeparationPending: false,
            getSeparationRes: payload,
            getSeparationError: null,
        },
    };
};
const handleGetSeparationError = (state1, payload) => ({
    ...state1,
    ...{
        getSeparationPending: false,
        getSeparationRes: null,
        getSeparationError: payload,
    },
});

/* Get Separation Approval Reducers*/
const handleGetSeparationApprovalRequest = state1 => {
    return {
        ...state1,
        ...{
            getSeparationApprovalPending: true,
            getSeparationApprovalRes: null,
            getSeparationApprovalError: null,
        },
    };
};
const handleGetSeparationApprovalSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getSeparationApprovalPending: false,
            getSeparationApprovalRes: payload,
            getSeparationApprovalError: null,
        },
    };
};
const handleGetSeparationApprovalError = (state1, payload) => ({
    ...state1,
    ...{
        getSeparationApprovalPending: false,
        getSeparationApprovalRes: null,
        getSeparationApprovalError: payload,
    },
});

/* Approve Reject Separation Reducers*/
const handleApproveRejectSeparationRequest = state1 => {
    return {
        ...state1,
        ...{
            approveRejectSeparationPending: true,
            approveRejectSeparationRes: null,
            approveRejectSeparationError: null,
        },
    };
};
const handleApproveRejectSeparationSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            approveRejectSeparationPending: false,
            approveRejectSeparationRes: payload,
            approveRejectSeparationError: null,
        },
    };
};
const handleApproveRejectSeparationError = (state1, payload) => ({
    ...state1,
    ...{
        approveRejectSeparationPending: false,
        approveRejectSeparationRes: null,
        approveRejectSeparationError: payload,
    },
});

/* Get Clearance Question Reducers */
const handleGetClearanceQuestionRequest = state => {
    return {
        ...state,
        ...{
            getClearanceQuestionPending: true,
            getClearanceQuestionRes: null,
            getClearanceQuestionError: null,
        },
    };
};
const handleGetClearanceQuestionSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getClearanceQuestionPending: false,
            getClearanceQuestionRes: payload,
            getClearanceQuestionError: null,
        },
    };
};
const handleGetClearanceQuestionError = (state, payload) => ({
    ...state,
    ...{
        getClearanceQuestionPending: false,
        getClearanceQuestionRes: null,
        getClearanceQuestionError: payload,
    },
});


/* Apply Clearance Form Reducers */
const handleApplyClearanceFormRequest = state1 => {
    return {
        ...state1,
        ...{
            applyClearanceFormPending: true,
            applyClearanceFormRes: null,
            applyClearanceFormError: null,
        },
    };
};
const handleApplyClearanceFormSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            applyClearanceFormPending: false,
            applyClearanceFormRes: payload,
            applyClearanceFormError: null,
        },
    };
};
const handleApplyClearanceFormError = (state1, payload) => ({
    ...state1,
    ...{
        applyClearanceFormPending: false,
        applyClearanceFormRes: null,
        applyClearanceFormError: payload,
    },
});


/* Show Clearance Form Reducers */
const handleSeparationDetailsRequest = state1 => {
    return {
        ...state1,
        ...{
            separationDetailsPending: true,
            separationDetailsRes: null,
            separationDetailsError: null,
        },
    };
};
const handleSeparationDetailsSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            separationDetailsPending: false,
            separationDetailsRes: payload,
            separationDetailsError: null,
        },
    };
};
const handleSeparationDetailsError = (state1, payload) => ({
    ...state1,
    ...{
        separationDetailsPending: false,
        separationDetailsRes: null,
        separationDetailsError: payload,
    },
});

/* Show Clearance Form Reducers */
const handleGetClearanceRequest = state1 => {
    return {
        ...state1,
        ...{
            getClearancePending: true,
            getClearanceRes: null,
            getClearanceError: null,
        },
    };
};
const handleGetClearanceSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getClearancePending: false,
            getClearanceRes: payload,
            getClearanceError: null,
        },
    };
};
const handleGetClearanceError = (state1, payload) => ({
    ...state1,
    ...{
        getClearancePending: false,
        getClearanceRes: null,
        getClearanceError: payload,
    },
});


/* Clear Separation Store */
const clearSeparationStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_APPLY_SEPARATION_STORE':
            return {
                ...state,
                ...{
                    applySeparationPending: false,
                    applySeparationRes: null,
                    applySeparationError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_SEPARATION_APPROVAL_STORE':
            return {
                ...state,
                ...{
                    getSeparationApprovalPending: false,
                    getSeparationApprovalRes: null,
                    getSeparationApprovalError: null,
                },
            };
        case 'HANDLE_CLEAR_APPROVE_REJECT_SEPARATION_STORE':
            return {
                ...state,
                ...{
                    approveRejectSeparationPending: false,
                    approveRejectSeparationRes: null,
                    approveRejectSeparationError: null,
                },
            };
        case 'HANDLE_CLEAR_APPLY_CLEARANCE_FORM_STORE':
            return {
                ...state,
                ...{
                    applyClearanceFormPending: false,
                    applyClearanceFormRes: null,
                    applyClearanceFormError: null,
                },
            };
        default:
            return state;
    }
};



export default createReducer(
    {
        [actions.applySeparationRequest]: handleApplySeparationRequest,
        [actions.applySeparationSuccess]: handleApplySeparationSuccess,
        [actions.applySeparationError]: handleApplySeparationError,

        [actions.updateSeparationRequest]: handleUpdateSeparationRequest,
        [actions.updateSeparationSuccess]: handleUpdateSeparationSuccess,
        [actions.updateSeparationError]: handleUpdateSeparationError,

        [actions.getSeparationRequest]: handleGetSeparationRequest,
        [actions.getSeparationSuccess]: handleGetSeparationSuccess,
        [actions.getSeparationError]: handleGetSeparationError,

        [actions.getSeparationApprovalRequest]: handleGetSeparationApprovalRequest,
        [actions.getSeparationApprovalSuccess]: handleGetSeparationApprovalSuccess,
        [actions.getSeparationApprovalError]: handleGetSeparationApprovalError,

        [actions.approveRejectSeparationRequest]: handleApproveRejectSeparationRequest,
        [actions.approveRejectSeparationSuccess]: handleApproveRejectSeparationSuccess,
        [actions.approveRejectSeparationError]: handleApproveRejectSeparationError,

        [actions.getClearanceQuestionRequest]: handleGetClearanceQuestionRequest,
        [actions.getClearanceQuestionSuccess]: handleGetClearanceQuestionSuccess,
        [actions.getClearanceQuestionError]: handleGetClearanceQuestionError,

        [actions.applyClearanceFormRequest]: handleApplyClearanceFormRequest,
        [actions.applyClearanceFormSuccess]: handleApplyClearanceFormSuccess,
        [actions.applyClearanceFormError]: handleApplyClearanceFormError,

        [actions.separationDetailsRequest]: handleSeparationDetailsRequest,
        [actions.separationDetailsSuccess]: handleSeparationDetailsSuccess,
        [actions.separationDetailsError]: handleSeparationDetailsError,

        [actions.getClearanceRequest]: handleGetClearanceRequest,
        [actions.getClearanceSuccess]: handleGetClearanceSuccess,
        [actions.getClearanceError]: handleGetClearanceError,


        [actions.handleClearSeparationStore]: clearSeparationStore,
    },
    initialState,
);